"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.94 7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m3.512 0a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.163 8.492a.65.65 0 0 1 .354.849c-.446 1.085-1.53 1.566-2.507 1.58-.97.014-2.065-.43-2.521-1.473a.65.65 0 0 1 1.19-.52c.183.417.685.702 1.311.693.62-.009 1.132-.305 1.324-.774a.65.65 0 0 1 .849-.355",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SmileyFaceIcon16.js.map